"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganismId = void 0;
var OrganismId;
(function (OrganismId) {
    OrganismId["HARRIS_HAWK"] = "harrisHawk";
    OrganismId["ANTELOPE_SQUIRREL"] = "antelopeSquirrel";
    OrganismId["POCKET_MOUSE"] = "pocketMouse";
    OrganismId["IRONWOOD_TREE"] = "ironwoodTree";
    OrganismId["HUMMINGBIRD"] = "hummingbird";
    OrganismId["BOBCAT"] = "bobcat";
    OrganismId["BEE"] = "bee";
    OrganismId["SAGUARO"] = "saguaro";
    OrganismId["ELF_OWL"] = "elfOwl";
    OrganismId["TARANTULA"] = "tarantula";
    OrganismId["CACTUS_LONGHORN_BEETLE"] = "cactusLonghornBeetle";
    OrganismId["WHITE_WINGED_DOVE"] = "whiteWingedDove";
})(OrganismId = exports.OrganismId || (exports.OrganismId = {}));
//# sourceMappingURL=OrganismId.js.map